export default {
  deductionTypePercentage: 'percentage',
  deductionTypeFixed: 'fixed',
  getDeductible(promoCode, productId, subTotal) {
    if (promoCode.code !== undefined && promoCode.isValid !== undefined && promoCode.instance !== undefined) {
      if (promoCode.isValid) {
        let limitationProductId = promoCode.instance.limitationProductId
        if (limitationProductId === '' || limitationProductId.indexOf(productId) >= 0) {
          let deductionType = promoCode.instance.deductionType
          let deductionValue = promoCode.instance.deductionValue
          let deductible = 0
          switch (deductionType) {
            case Core.PromoCode.deductionTypeFixed:
              if (deductionValue <= subTotal) {
                deductible = deductionValue
              } else {
                deductible = subTotal
              }
              break
            case Core.PromoCode.deductionTypePercentage:
              let deductiblePercent = (deductionValue / 100) * subTotal
              if (deductiblePercent <= subTotal) {
                deductible = deductiblePercent
              } else {
                deductible = subTotal
              }
              break
          }

          return deductible
        }
      }
    }
    return false
  }
}
